import { render, staticRenderFns } from "./delete-topic.vue?vue&type=template&id=d99068b0&scoped=true&"
import script from "./delete-topic.ts?vue&type=script&lang=ts&"
export * from "./delete-topic.ts?vue&type=script&lang=ts&"
import style0 from "./delete-topic.scss?vue&type=style&index=0&id=d99068b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99068b0",
  null
  
)

export default component.exports